import { APP_ROUTES } from '@/constants/pages';
import { _s } from '@/locale';
import { AccountNavItem, AccountNavItemIdentifier } from './AccountNavigation.types';

const baseTranslationKey = 'features.account-navigation.constants';

const PROFILE_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.Profile,
  label: _s(`${baseTranslationKey}.PROFILE_NAV_ITEM.label`),
  icon: 'contact-card',
  to: APP_ROUTES.MY_PROFILE,
};

const FAVORITES_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.Favorites,
  label: _s(`${baseTranslationKey}.FAVORITES_NAV_ITEM.label`),
  icon: 'heart',
  to: APP_ROUTES.MY_FAVORITES,
};

const BOOKINGS_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.Bookings,
  label: _s(`${baseTranslationKey}.BOOKINGS_NAV_ITEM.label`),
  icon: 'calendar-user',
  to: APP_ROUTES.MY_BOOKINGS,
};

const PAYMENT_METHODS_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.PaymentMethods,
  label: _s(`${baseTranslationKey}.PAYMENT_METHODS_NAV_ITEM.label`),
  icon: 'credit-card',
  to: APP_ROUTES.PAYMENT_METHODS,
};

const BUNDLES_NAV_ITEM: AccountNavItem = {
  identifier: AccountNavItemIdentifier.Bundles,
  label: _s(`${baseTranslationKey}.BUNDLES_NAV_ITEM.label`),
  icon: 'punch-card',
  to: APP_ROUTES.MY_BUNDLES_VALID,
};

export const ACCOUNT_NAV_ITEMS = [
  PROFILE_NAV_ITEM,
  FAVORITES_NAV_ITEM,
  BOOKINGS_NAV_ITEM,
  PAYMENT_METHODS_NAV_ITEM,
  BUNDLES_NAV_ITEM,
];
